export default __webpack_public_path__ + "static/corporate-ugandans-cf3c2c95fef05c4dcd2bb91d83055b97.jpg";